/**
 * Variant Selects Web Component
 * Dynamic variant switching, price update, and section re-rendering
 */

window.themeBus = window.themeBus || {
  events: {},
  subscribe(event, callback) {
    if (!this.events[event]) this.events[event] = [];
    this.events[event].push(callback);
    return () => {
      this.events[event] = this.events[event].filter(cb => cb !== callback);
    };
  },
  publish(event, data) {
    if (this.events[event]) {
      this.events[event].forEach(cb => {
        try { cb(data); } catch (e) { console.error('themeBus listener error:', e); }
      });
    }
  }
};
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedLabel();

    if (!this.currentVariant) {
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updatePrice();
      this.updateButton();
      if (window.themeBus && typeof window.themeBus.publish === 'function') {
        window.themeBus.publish('variant:changed', {
          sectionId: this.dataset.section,
          variant: this.currentVariant
        });
      }
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      const radio = fieldset.querySelector('input:checked');
      if (radio) return radio.value;
      const select = fieldset.querySelector('select');
      return select ? select.value : null;
    });
  }

  updateSelectedLabel() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    fieldsets.forEach((fieldset, idx) => {
      const label = fieldset.querySelector('.variant-selected-value');
      if (label && this.options[idx]) {
        label.textContent = this.options[idx];
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });

    const masterInput = document.querySelector(`#product-form-${this.dataset.section} input[name="id"]`)
      || document.querySelector('product-form form input[name="id"]')
      || document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (masterInput && this.currentVariant) {
      masterInput.value = this.currentVariant.id;
      masterInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;
    const mediaId = this.currentVariant.featured_media.id;
    const targetSlide = document.querySelector(`[data-media-id="${mediaId}"]`);
    if (targetSlide) {
      targetSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updatePrice() {
    const priceEl = document.querySelector(`#price-${this.dataset.section}`);
    if (!priceEl || !this.currentVariant) return;

    const moneyFormat = (window.themeSettings && window.themeSettings.moneyFormat) || '₹{{amount}}';
    const formatMoney = (cents) => {
      const val = (cents / 100).toFixed(2);
      const valNoDec = (cents / 100).toFixed(0);
      return moneyFormat
        .replace('{{amount}}', val)
        .replace('{{amount_no_decimals}}', valNoDec)
        .replace('{{amount_with_comma_separator}}', val.replace('.', ','));
    };

    const regularItem = priceEl.querySelector('.price-item--regular');
    const saleItem = priceEl.querySelector('.price-item--sale');

    if (this.currentVariant.compare_at_price > this.currentVariant.price) {
      priceEl.classList.add('price--on-sale');
      if (saleItem) saleItem.textContent = formatMoney(this.currentVariant.price);
      if (regularItem) regularItem.textContent = formatMoney(this.currentVariant.compare_at_price);
    } else {
      priceEl.classList.remove('price--on-sale');
      if (regularItem) regularItem.textContent = formatMoney(this.currentVariant.price);
    }

    // Update quantity breaks tier prices for this section
    const qtyBreaks = document.querySelector(`.qty-breaks[data-section-id="${this.dataset.section}"], .qty-breaks`);
    if (qtyBreaks && typeof qtyBreaks.updateTierPrices === 'function') {
      qtyBreaks.updateTierPrices(this.currentVariant);
    }
  }

  updateButton() {
    const section = this.dataset.section;
    const button = document.querySelector(`#product-form-${section} button[type="submit"]`);
    const isAvail = Boolean(this.currentVariant && this.currentVariant.available);

    if (button) {
      if (!isAvail) {
        button.setAttribute('disabled', 'disabled');
        const text = button.querySelector('.button__text') || button;
        text.textContent = (window.variantStrings && window.variantStrings.soldOut) || 'Sold Out';
      } else {
        button.removeAttribute('disabled');
        const text = button.querySelector('.button__text') || button;
        text.textContent = (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';
      }
    }

    // Toggle dynamic checkout button
    const paymentTerms = document.querySelector(`#product-form-${section} .shopify-payment-terms`);
    if (paymentTerms) paymentTerms.style.display = isAvail ? '' : 'none';

    // Toggle quantity selector block
    const qtySelector = document.querySelector('.product-v2__block--quantity_selector, .product-v2__quantity-selector-wrap');
    if (qtySelector) qtySelector.style.display = isAvail ? '' : 'none';

    // Toggle quantity breaks / tiers block
    const qtyBreaks = document.querySelector('.product-v2__block--quantity_breaks, .qty-breaks');
    if (qtyBreaks) qtyBreaks.style.display = isAvail ? '' : 'none';

    // Toggle Back in Stock / Notify Me form
    const notifyForm = document.querySelector('#back-in-stock-form-wrapper, #back-in-stock-form, .product-v2__notify-me');
    if (notifyForm) notifyForm.style.display = isAvail ? 'none' : '';

    // Toggle Sticky ATC bar button
    const stickyBtn = document.querySelector('.sticky-atc__btn');
    if (stickyBtn) {
      stickyBtn.style.display = isAvail ? '' : 'none';
      if (!isAvail) stickyBtn.setAttribute('disabled', 'disabled');
      else stickyBtn.removeAttribute('disabled');
    }
    const stickySoldOut = document.querySelector('.sticky-atc__sold-out-badge');
    if (stickySoldOut) stickySoldOut.style.display = isAvail ? 'none' : '';
  }

  setUnavailable() {
    const section = this.dataset.section;
    const button = document.querySelector(`#product-form-${section} button[type="submit"]`);
    if (button) {
      button.setAttribute('disabled', 'disabled');
      const text = button.querySelector('.button__text') || button;
      text.textContent = (window.variantStrings && window.variantStrings.unavailable) || 'Unavailable';
    }
    const paymentTerms = document.querySelector(`#product-form-${section} .shopify-payment-terms`);
    if (paymentTerms) paymentTerms.style.display = 'none';
    const qtySelector = document.querySelector('.product-v2__block--quantity_selector, .product-v2__quantity-selector-wrap');
    if (qtySelector) qtySelector.style.display = 'none';
    const qtyBreaks = document.querySelector('.product-v2__block--quantity_breaks, .qty-breaks');
    if (qtyBreaks) qtyBreaks.style.display = 'none';
    const notifyForm = document.querySelector('#back-in-stock-form-wrapper, #back-in-stock-form, .product-v2__notify-me');
    if (notifyForm) notifyForm.style.display = '';
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('script[type="application/json"]').textContent);
    return this.variantData;
  }
}

if (!customElements.get('variant-selects')) {
  customElements.define('variant-selects', VariantSelects);
}
